import { http } from "@/http";
import { initCsrf } from "@/http/csrf";

export async function loginCompanyByCnpj(payload) {
  await initCsrf();
  return http.post("/portal/login-cnpj", payload);
}

export async function loginCompanyByToken(payload) {
  await initCsrf();
  return http.post("/portal/auth", payload);
}

export async function getCompanyMe() {
  return http.get("/portal/me");
}

export async function logoutCompany() {
  return http.post("/portal/logout");
}
